// Resgates aguardando entrega no balcão -- mesmo padrão de
// useRankPromotionPendingPoll.js: endpoint de contagem dedicado
// (GET /admin/redemptions/pending-count) + poll espaçado.
import { onMounted, onUnmounted } from 'vue'
import { getPendingRedemptionsCount } from '@/services/adminService'
import { useAuthStore } from '@/stores/auth.store'
import { setNotificationCount, canSeeNotificationSource } from './registry'

const KEY     = 'resgate-pendente'
const POLL_MS = 60_000 // 1min -- criança esperando no balcão, mais urgente que os demais avisos

export function useRedemptionPendingPoll() {
  let timer = null
  const auth = useAuthStore()

  async function fetchOnce() {
    if (document.hidden) return
    try {
      const { data } = await getPendingRedemptionsCount()
      setNotificationCount(KEY, data.count)
    } catch {
      // Falha de rede não deve gerar erro visível por causa de um badge --
      // mantém a última contagem conhecida até o próximo poll funcionar.
    }
  }

  onMounted(() => {
    if (!canSeeNotificationSource(KEY, auth.role)) return
    fetchOnce()
    timer = setInterval(fetchOnce, POLL_MS)
  })

  onUnmounted(() => {
    if (timer) clearInterval(timer)
  })
}
